import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';
import DeliveryIcon from 'assets/icons/delivery';
import CallIcon from 'assets/icons/call';

export const StyledContainer = styled('div')(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    display: isDesktop ? 'flex' : 'block',
    padding: isDesktop ? theme.spacing(4, 10) : theme.spacing(2),
    justifyContent: 'space-between',
    backgroundColor: theme.colors.paletteFromBO.main,
    color: theme.palette.grey[100],
    '& *': {
      fontSize: isDesktop ? 16 : 14,
    },
  }),
);

export const StyledProgramHoursContainer = styled('div')(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    width: isDesktop ? 790 : '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: isDesktop ? 0 : theme.spacing(2),
  }),
);

export const StyledProgramHours = styled(Typography)(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    textAlign: isDesktop ? 'left' : 'center',
  }),
);

export const StyledTypography = styled(Typography)(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    textAlign: 'center',
  }),
);

export const StyledDeliveryAndSalesContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    textAlign: 'center',
    gap: theme.spacing(3),
  }),
);

export const StyledDeliveryAndSalesChild = styled('div')(() => ({
  width: '50%',
}));

export const StyledDeliveryIcon = styled(DeliveryIcon)(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    width: isDesktop ? 108 : 78,
    height: isDesktop ? 50 : 40,
    marginBottom: theme.spacing(1),
  }),
);

export const StyledCallIcon = styled(CallIcon)(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    width: isDesktop ? 108 : 78,
    height: isDesktop ? 50 : 40,
    marginBottom: theme.spacing(1),
  }),
);
